<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <path class="a" d="M15.5 0.501L18.5 0.501 15.5 3.501 18.5 3.501" />

        <path class="a" d="M18.5 6.501L23.5 6.501 18.5 11.501 23.5 11.501" />

        <path
            class="a"
            d="M14,13.5a6,6,0,0,0-12,0V19A1.5,1.5,0,0,1,.5,20.5h15A1.5,1.5,0,0,1,14,19Z"
        />

        <path class="a" d="M9.415,22.5a1.5,1.5,0,0,1-2.829,0" />

        <path class="a" d="M8 5.501L8 7.501" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'AlarmBellIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
